import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {StorageService} from '../../../../Services/storage.service';
import {DataService} from '../../../../Services/data.service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {FilterPipe} from 'ngx-filter-pipe';
import {NotificationService} from '../../../../Services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DataExportService} from '../../../../Services/dataExport.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {HelperService} from '../../../../Services/helper/helper.service';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-income-statement',
  templateUrl: './income-statement.component.html',
  styleUrls: ['./income-statement.component.css'],
  standalone: false
})
export class IncomeStatementComponent implements OnInit, AfterViewInit, AfterViewChecked{
  @ViewChild('ExcelExport', {static: false}) ExcelExport: ElementRef;
  private rptName: string;
  lapCount = 0;
  public vm: any = {
    toDateSelect: [],
    fromDateSelect: [],
    DataFormat: 'MM/DD/YYYY',
    dateError: false,
    report: [],
    request: {
      toDate: null,
      fromDate: null,
      location_group_id: false,
      columns: '',
      company_id: null,
      location_id: null,
      rf_id_1: null,
      rf_id_2: null,
      rf_id_3: null,
      rf_id_4: null,
      rf_id_5: null,
      account_type_id: null,
      account_parent_id: null,
      account_subtotal_id: null
    },
    showSpecificDates: false,
    buttonsDisabled: false,
    d: {
      date: '',
      name: ''
    },
    columns: false,
    company: [],
    locationGroup: [],
    location: [],
    currency: [],
    rfType: [],
    rf1: [],
    rf2: [],
    rf3: [],
    rf4: [],
    rf5: [],
    filtered: false,
    showFilters: false,
    toDateError: false,
    totalDebits: 0,
    totalCredits: 0,
    liabEquityCurrent: 0,
    liabEquityPrior: 0,
    totalCurrentAssets: 0,
    totalPriorAssets: 0,
    companyData: null,
    locationData: null,
    calculatedTime: new Date(),
    priorToDate: 0,
    priorFromDate: 0,
    ToEmailError: null,
    showEmail: true,
    emailed: null,
    email: {
      toemail: null,
      fromemail: this.appConfigService.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    monthCount: null,
    netIncomeCurrent: null,
    netIncomePrior: null,
    pdfFileName: null,
    totalCurrentRevenue: null,
    totalPriorRevenue: null,
    marginCurrent: null,
    marginPrior: null,
    fromDateError: null,
    accountTypeName: null,
    accountParentName: null,
    accountSubtotalName: null,
    accountSubtotal: null,
    accountParents: null,
    accountType: null,
    companyName: null,
    locationName: null,
    locationGroupName: null,
    rf1Name: null,
    rf2Name: null,
    rf3Name: null,
    rf4Name: null,
    rf5Name: null,
    accountInput: null,
    entityInput: null,
    Preferences: null,
    permissions: null,
    inventoryItem: [],
    entityState: [],
    entityCity: [],
    entityType: [],
    user: [],
    paymentType: [],
    bank: [],
    entityFilter: [],
    entity: [],
    inventoryItemFilter: [],
    exportToExcel: true,
  };

  // Email modal integration
  reportDataToSendInEmail: EmailModel = new EmailModel();
  // Standard report header button configuration
  buttonConfig: any = {
    reportFormat: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  constructor(
    public localStorage: StorageService,
    public tableDataService: DataService,
    private titleService: Title,
    public appConfigService: AppConfigService,
    public dateFilter: DateFilterService,
    public notification: NotificationService,
    public route: ActivatedRoute,
    public excelExporter: DataExportService,
    private router: Router,
    private helperService: HelperService,
    private reportPrint: ReportPrintService,
    private destroyRef: DestroyRef,
  ) {
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    this.vm.email.toemail = this.localStorage.StorageGet('ToEmail', '');
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      let hasUrlDates = false;
      if (params.toDate !== undefined) {
        this.vm.request.toDate = params.toDate;
        this.vm.showSpecificDates = true;
        hasUrlDates = true;
      }
      if (params.fromDate !== undefined) {
        this.vm.request.fromDate = params.fromDate;
        this.vm.showSpecificDates = true;
        hasUrlDates = true;
      }

      if (!this.vm.request.toDate && !this.vm.request.fromDate) {
        this.newDateFilter(new Date(), new Date());
        this.primeDefaultDateRange();
      }

      this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);

      if (hasUrlDates && this.vm.request.toDate && this.vm.request.fromDate) {
        this.update();
      }
      this.vm.request.columns = 'actual';
    });

    this.FilterOptionsInit();
    // this.EmailInit();
    this.rptName = $localize`:Income Statement @@incomeStatement:Income Statement`;
  }

  private primeDefaultDateRange() {
    const range = this.dateFilter.GetDefaultDateRange('currentMonth', this.vm.fromDateSelect, this.vm.toDateSelect);
    this.vm.request.toDate = range.toDate;
    this.vm.request.fromDate = range.fromDate;
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
  }

  ngAfterViewChecked() {
    // No-op: legacy email pass-through removed in favor of SendEmailModalComponent
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    const reportName = 'Income Statement';

    // printing options
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Use the same HTML as printing to ensure consistency
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      // Fallback to raw export HTML if builder fails
      try {
        const html = (this.ExcelExport?.nativeElement?.outerHTML
          || document.getElementById('excel-export')?.outerHTML
          || '');
        emailDocObj.pdfHtml = html;
      } catch {
        emailDocObj.pdfHtml = '';
      }
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Income_Statement_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    // Open the shared modal; defer to ensure @Input propagates
    const openModal = () => {
      const element = document.getElementById('sendEmailModal') as HTMLElement;
      if (element) {
        const emailModal = new Modal(element);
        emailModal.show();
      }
    };

    setTimeout(openModal, 0);
  }

  exportToExcel() {
    this.excelExporter.exportToExcel(this.ExcelExport, this.rptName + '.xlsx');
  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  // Print the report content using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.reportPrint.printInIframe(html);
    } catch (e) {
      console.error('Income Statement print failed', e);
    }
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const content = this.reportPrint.cleanContentHtml((this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString());
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: `${from} to ${to}`});
    }
    return this.reportPrint.buildHtml({title: 'Income Statement', contentHtml: content, meta, orientation: 'landscape'});
  }

  FilterOptionsInit() {
    this.tableDataService.getData('company?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.company = result.Data;
    });
    this.tableDataService.getData('currency?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.currency = result.Data;
    });
    this.tableDataService.getData('location?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.location = result.Data;
      // console.log('locs: ' +  this.vm.location);
    });
    this.tableDataService.getData('location_group?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.locationGroup = result.Data;
    });
    this.tableDataService.getData('reporting_field_type?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.rfType = result.Data;
    });
    this.tableDataService.getData('reporting_field', '?state=active&type_id=rf1&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.rf1 = result.Data;
    });
    this.tableDataService.getData('reporting_field', '?state=active&type_id=rf2&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.rf2 = result.Data;
    });
    this.tableDataService.getData('reporting_field', '?state=active&type_id=rf3&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.rf3 = result.Data;
    });
    this.tableDataService.getData('reporting_field', '?state=active&type_id=rf4&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.rf4 = result.Data;
    });
    this.tableDataService.getData('reporting_field', '?state=active&type_id=rf5&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.rf5 = result.Data;
    });
  }

  EmailInit() {
    // this.vm.email.toemail = this.localStorage.StorageGet('ToEmail');
  }

  calcTotals() {
    this.vm.totalDebits = this.vm.totalCredits = this.vm.netIncomeCurrent = this.vm.netIncomePrior = this.vm.netIncomeBudget = 0;
    this.vm.totalCurrentRevenue = this.vm.totalPriorRevenue = this.vm.totalBudgetRevenue = 0;
    this.vm.marginCurrent = this.vm.marginPrior = this.vm.marginBudget = 0;
    const revenueItem = this.vm.report.find(item => item.title === 'Revenue');
    if (revenueItem) {
      this.vm.totalCurrentRevenue = Number(revenueItem.totalCurrentPeriod);
      this.vm.totalPriorRevenue = Number(revenueItem.totalPriorPeriod);
      if (revenueItem.totalBudget !== null && revenueItem.totalBudget !== undefined) {
        this.vm.totalBudgetRevenue = Number(revenueItem.totalBudget);
      } else {
        // Fallback to summing parents' budgets if top-level totalBudget is missing
        this.vm.totalBudgetRevenue = revenueItem.parents.reduce((acc, parent) => acc + (Number(parent.budget) || 0), 0);
      }
    }

    for (const reportItem of this.vm.report) {
      const budgetValue = (reportItem.totalBudget !== null && reportItem.totalBudget !== undefined)
        ? Number(reportItem.totalBudget)
        : reportItem.parents.reduce((acc, parent) => acc + (Number(parent.budget) || 0), 0);

      if (reportItem.title === 'Revenue') {
        this.vm.netIncomeCurrent += Number(reportItem.totalCurrentPeriod);
        this.vm.netIncomePrior += Number(reportItem.totalPriorPeriod);
        this.vm.netIncomeBudget += budgetValue;
      } else {
        if (reportItem.title === 'Costs') {
          this.vm.marginCurrent = this.vm.totalCurrentRevenue - Number(reportItem.totalCurrentPeriod);
          this.vm.marginPrior = this.vm.totalPriorRevenue - Number(reportItem.totalPriorPeriod);
          this.vm.marginBudget = this.vm.totalBudgetRevenue - budgetValue;
        }
        this.vm.netIncomeCurrent -= Number(reportItem.totalCurrentPeriod);
        this.vm.netIncomePrior -= Number(reportItem.totalPriorPeriod);
        this.vm.netIncomeBudget -= budgetValue;
      }
    }
  }

  FilterObject(value, filterObj, except = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  update() {
    this.lapCount++;

    this.vm.report = [];
    let errorDescription = '';
    this.vm.toDateError = this.vm.fromDateError = false;
    if (!this.vm.request.fromDate) {
      errorDescription += $localize`:A from date is required. @@afromdateisrequired:A from date is required.` + ' ';
      this.vm.fromDateError = true;
    }
    if (!this.vm.request.toDate) {
      errorDescription += $localize`:A To date is required. @@aTodateisrequired:A To date is required.` + ' ';
      this.vm.toDateError = true;
    }

    const tempToDate: any = new Date(this.vm.request.toDate);
    const tempFromDate: any = new Date(this.vm.request.fromDate);

    if (tempToDate < tempFromDate) {
      errorDescription += $localize`:From date must be less than the To date @@fromdatemustbelessthantheTodate:From date must be less than the To date`;
      this.vm.toDateError = true;
      this.vm.fromDateError = true;
    }
    if (errorDescription) {
      this.notification.warning(errorDescription);
    } else {
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);

      this.vm.monthCount = (tempToDate - tempFromDate) / 86400 / 30 / 1000;
      this.vm.buttonsDisabled = true;
      this.vm.netIncomeCurrent = this.vm.netIncomePrior = this.vm.netIncomeBudget = 0;

      let paramString = '';
      if (this.vm.request.fromDate) {
        paramString += '&fromDate=' + this.vm.request.fromDate;
      }
      if (this.vm.request.toDate) {
        paramString += '&toDate=' + this.vm.request.toDate;
      }
      if (this.vm.request.company_id) {
        paramString += '&company_id=' + this.vm.request.company_id;
      }
      if (this.vm.request.location_id) {
        paramString += '&location_id=' + this.vm.request.location_id;
      }
      if (this.vm.request.location_group_id) {
        paramString += '&location_group_id=' + this.vm.request.location_group_id;
      }
      if (this.vm.request.rf_id_1) {
        paramString += '&rf_id_1=' + this.vm.request.rf_id_1;
      }
      if (this.vm.request.rf_id_2) {
        paramString += '&rf_id_2=' + this.vm.request.rf_id_2;
      }
      if (this.vm.request.rf_id_3) {
        paramString += '&rf_id_3=' + this.vm.request.rf_id_3;
      }
      if (this.vm.request.rf_id_4) {
        paramString += '&rf_id_4=' + this.vm.request.rf_id_4;
      }
      if (this.vm.request.rf_id_5) {
        paramString += '&rf_id_5=' + this.vm.request.rf_id_5;
      }

      if (paramString[0] === '&') {
        paramString = paramString.substring(1);
      }

      this.tableDataService.getData('income_statement', '?' + paramString).subscribe((result: any[]) => {
        this.vm.report = result;
        // console.log('income statement data', result);
        this.vm.filtered = false;
        this.vm.showFilters = this.vm.buttonsDisabled = false;
        this.calcTotals();
        this.lapCount = 0;
      });
      // return false;
    }
  }

  parseInt(val) {
    return parseInt(val, 10);
  }

  close() {
    this.router.navigateByUrl('/home').then();
  }

  clear(clear = false) {
    let inventoryItemInput: any;
    this.vm.report = [];
    this.vm.buttonsDisabled = false;
    if (clear) {
      this.vm.showEmail = false;
      this.vm.accountInput = this.vm.entityInput = inventoryItemInput = '';
      this.vm.report = [];
      this.vm.request = {
        toDate: null,
        fromDate: null,
        location_group_id: false,
        columns: '',
        company_id: null,
        location_id: null,
        rf_id_1: null,
        rf_id_2: null,
        rf_id_3: null,
        rf_id_4: null,
        rf_id_5: null,
        account_type_id: null,
        account_parent_id: null,
        account_subtotal_id: null
      };
    }
  }

  Print() {
    return window.print();
  }
}
